import Slider from 'react-slick'
import { Button, Hidden } from '@mui/material'
import SampleArrow from './SampleArrow' // Assuming SampleArrow is in the same directory or correctly imported

/**
 * Renders the group navigation sliders for desktop and mobile views.
 *
 * @param {object} props - The component props.
 * @param {Array<object>} props.gruposKeys - The list of group keys with their state.
 * @param {function} props.handleContent - Callback to handle group selection.
 * @param {number} props.indexContent - The currently selected group index.
 * @param {boolean} props.testMode - Indicates if the report is in test mode.
 */
const PautaGroupSlider = ({ gruposKeys, handleContent, indexContent, testMode }) => {
    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 7,
        nextArrow: <SampleArrow />,
        prevArrow: <SampleArrow />,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    }

    const settingsMovile = {
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }

    const displayGroups = testMode ? [gruposKeys[0], gruposKeys[1], gruposKeys[2]] : gruposKeys

    return (
        <>
            <Hidden mdDown>
                <div style={{ height: 70, borderColor: '#ccc', borderWidth: 2, borderStyle: 'solid', borderRadius: 10 }}>
                    <Slider {...settings}>
                        {displayGroups.map((element, index) => (
                            <div
                                key={index}
                                style={{
                                    textAlign: 'center',
                                    height: '100%'
                                }}>
                                <Button
                                    style={{
                                        borderRadius: 10,
                                        marginTop: 2.5,
                                        border: element.tieneBacklog ? '#BB2D2D 1px solid' : null,
                                        textAlign: 'center',
                                        width: '90%',
                                        height: 60,
                                        padding: '2px 4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={() => handleContent(index, element.data)}>
                                    <p style={{
                                        margin: 0,
                                        fontSize: '11px',
                                        lineHeight: '1.2',
                                        wordBreak: 'break-word',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        textTransform: 'none'
                                    }}>{element.data}</p>
                                </Button>
                                {element.state && (
                                    <div style={{ width: '90%', height: 6, backgroundColor: '#BB2D2D', position: 'relative', marginLeft: '5%', bottom: 5, borderRadius: 5 }}></div>
                                )}
                            </div>
                        ))}
                    </Slider>
                </div>
            </Hidden>
            <Hidden mdUp>
                <div style={{ borderColor: '#ccc', borderWidth: 2, borderStyle: 'solid', borderRadius: 10, width: '100%' }}>
                    <Slider {...settingsMovile}>
                        {displayGroups.map((element, index) => (
                            <div
                                key={index}
                                style={{
                                    textAlign: 'center',
                                    height: '100%'
                                }}>
                                <Button
                                    style={{
                                        borderRadius: 10,
                                        border: element.tieneBacklog ? '#BB2D2D 1px solid' : null,
                                        textAlign: 'center',
                                        width: '90%',
                                        height: 60,
                                        padding: '2px 4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={() => handleContent(index, element.data)}>
                                    <p style={{
                                        margin: 0,
                                        fontSize: '11px',
                                        lineHeight: '1.2',
                                        wordBreak: 'break-word',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        textTransform: 'none'
                                    }}>{element.data}</p>
                                </Button>
                                {element.state && (
                                    <div style={{ width: '90%', height: 6, backgroundColor: '#BB2D2D', position: 'relative', marginLeft: '5%', bottom: 5, borderRadius: 5 }}></div>
                                )}
                            </div>
                        ))}
                    </Slider>
                </div>
            </Hidden>
        </>
    )
}

export default PautaGroupSlider
